import { render } from "./SidepanelHeader.vue?vue&type=template&id=681370a6&scoped=true"
import script from "./SidepanelHeader.vue?vue&type=script&lang=js"
export * from "./SidepanelHeader.vue?vue&type=script&lang=js"

import "./SidepanelHeader.vue?vue&type=style&index=0&id=681370a6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-681370a6"]])

export default __exports__